var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner)?_c('div',{staticClass:"text-center banner-preview grey lighten-4"},[(_vm.banner)?_c('img',{attrs:{"src":_vm.previewUrl}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }